import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { StorageService } from '../../services/storage.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-bridge',
  standalone: true,
  imports: [],
  templateUrl: './bridge.component.html',
  styleUrl: './bridge.component.scss',
})
export class BridgeComponent {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private authService: AuthService,
  ) {}

  async ngOnInit() {
    this.route.params.subscribe(async (params: Params) => {
      const token: string = params['token'];
      const mobile: string = params['mobile'];

      if (token === undefined || token === null) {
        return;
      }

      if (mobile !== undefined && mobile !== null) {
        this.storageService.setMobile(mobile);
      }

      await this.setupAccount(decodeURIComponent(token));
    });
  }

  async setupAccount(token: string) {
    this.storageService.setToken(token);
    const user = await firstValueFrom(this.authService.getUserInfoOrRefreshIfNeeded());

    if (user.is_first_connection) {
      this.router.navigate(['/onboarding/1']);
    } else {
      this.router.navigate(['']);
    }
  }
}
